import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  MFA_PREFERENCE_FEATURE_KEY,
  MfaPreferenceState,
} from './mfa-preference.reducer';

// Lookup the 'EnableMfa' feature state managed by NgRx
export const selectEnableMfaState = createFeatureSelector<MfaPreferenceState>(
  MFA_PREFERENCE_FEATURE_KEY,
);

export const selectEnableMfaLoaded = createSelector(
  selectEnableMfaState,
  (state: MfaPreferenceState) => state.loaded,
);

export const selectEnableMfaLoading = createSelector(
  selectEnableMfaState,
  (state: MfaPreferenceState) => state.loading,
);

export const selectEnableMfaError = createSelector(
  selectEnableMfaState,
  (state: MfaPreferenceState) => state.error,
);

export const selectMfAPreference = createSelector(
  selectEnableMfaState,
  (state) => {
    return state.mFAPreference;
  },
);
export const selectChangeTOTPMfAPreference = createSelector(
  selectEnableMfaState,
  (state) => {
    return state.changeTOTP;
  },
);

export const isSmsMfaEnabled = createSelector(
  selectMfAPreference,
  (mfaPreference): boolean => {
    if (
      mfaPreference?.enabled &&
      mfaPreference.enabled.length &&
      mfaPreference.enabled.indexOf('SMS') != -1
    ) {
      return true;
    }
    return false;
  },
);
export const isAuthenticatorMfaEnabled = createSelector(
  selectMfAPreference,
  (mfaPreference) => {
    if (
      mfaPreference?.enabled &&
      mfaPreference.enabled.length &&
      mfaPreference.enabled.indexOf('TOTP') != -1
    ) {
      return true;
    }
    return false;
  },
);
